import { qsa } from "@fluorescent/dom";
import { section } from "@/glow";
import { emit } from "@/glow/events";

import { backgroundVideoHandler } from "@/lib/a11y";
import autoPlay from "../lib/auto-play";

const selectors = {
  video: ".video-hero__video",
};

section("video-hero", {
  videoHandler: null,
  onLoad() {
    const video = qsa(selectors.video, this.container);

    if (video.length) {
      this.videoHandler = backgroundVideoHandler(this.container);
      autoPlay(video);
    }
  },

  onSelect() {
    emit("transparentSectionUpdate");
  },

  onUnload() {
    this.videoHandler && this.videoHandler();
  },
});
